/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { styled } from '@mui/material';

export const TextIconButton = styled('button')`
  text-decoration: none;
  color: ${({ theme, color }) => color ?? theme.colors.shade0};
  display: inline-flex;
  gap: 8px;
  word-break: break-all;
  p {
    text-underline-offset: 2px;
    text-decoration-thickness: 1px;
  }
  .material-symbols-outlined {
    color: ${({ theme, color }) => color ?? theme.colors.secondary100};
  }
  cursor: pointer;
  border: none;
  background-color: transparent;
`;
